/** Strip trailing slashes so paths like `/api/...` join correctly. */
function baseUrl(url) {
    if (!url || typeof url !== "string") return "";
    return url.replace(/\/+$/, "");
}

/**
 * Centralized Configuration Management.
 * Fetch values from environment variables with safe defaults for local development.
 * Professional practice: No hardcoded secrets or environment-specific logic here.
 */
const config = {
    // Environment metadata
    ENV: process.env.REACT_APP_ENV || "development",

    // Application URLs
    API_URL: baseUrl(process.env.REACT_APP_API_URL),
    FRONT_URL: baseUrl(process.env.REACT_APP_FRONT_URL),
    ADMIN_URL: baseUrl(process.env.REACT_APP_ADMIN_URL),
    SOCKET_URL: baseUrl(
        process.env.REACT_APP_SOCKET_URL ||
        process.env.REACT_APP_API_URL
    ),

    // Solana USDT crypto-payment constants (from the payments repo).
    // Consumed by the crypto Wallet.jsx / WalletProvider.jsx (present but not wired into the active app).
    USDT_TOKEN: "EPbzBL1ygWHr4nadkyb4Akke6Eta7RpWrHmwS3pkCdBy",
    PLATFORM_WALLET: "A8KBjwYe1Xqe41cWyNc7mQKpechqkZdGtv9AmB1MzQ2N",
    PROGRAM_ID: "CkeZdjmqQGSBGPJkcQiFxxhpNbgKeVyQVB85XE9MbD8u",

    // Static Resource URLs
    AUTHENTICATOR_URL: {
        PLAY_STORE: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
        APP_STORE: "https://apps.apple.com/us/app/google-authenticator/id388497605",
    },
};

export default config;
